import { render, staticRenderFns } from "./RandomBox.vue?vue&type=template&id=e6f7ff0c&scoped=true&"
import script from "./RandomBox.vue?vue&type=script&lang=js&"
export * from "./RandomBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f7ff0c",
  null
  
)

export default component.exports